var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello",attrs:{"id":"container"}},[_c('div',{staticClass:"stage_title--sub"},[_c('h1',[_vm._v(_vm._s(_vm.subheading))]),_c('p',[_vm._v(_vm._s(_vm.body))]),_c('p',[_vm._v(_vm._s(_vm.footer))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }